var cbURL;

if (process.env.NODE_ENV === "development") {
  cbURL = "http://localhost:8081/authcallback";
} else {
  cbURL = "https://dashboard.mindsight.io/authcallback";
}

export const AUTH_CONFIG = {
  clientId: "Vm7uSbzBr0WcOKazPlOFFp9PHUZKr9ME",
  domain: "mindsight.auth0.com",
  audience: "https://api.mindsight.io/",
  callbackURL: cbURL
};
